"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isInteger2 = _interopRequireDefault(require("lodash/isInteger"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Count = _interopRequireDefault(require("../../Common/Count"));
var _TimeFrom = _interopRequireDefault(require("../../Common/TimeFrom"));
var _Messenger = _interopRequireDefault(require("../Messenger"));
var _constants = require("../../../../constants");
var _iconsReact = require("../../../../icons-react");
var _excluded = ["type", "title", "time", "to", "unreadAmount", "isHasStatus", "messageStatus", "isCreateNewConversation"];
var Types = _Messenger["default"].Types;
var ConversationCard2 = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var type = _ref.type,
    title = _ref.title,
    time = _ref.time,
    to = _ref.to,
    unreadAmount = _ref.unreadAmount,
    isHasStatus = _ref.isHasStatus,
    messageStatus = _ref.messageStatus,
    isCreateNewConversation = _ref.isCreateNewConversation,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var messageStatusIcon;
  switch (messageStatus) {
    case _constants.MESSAGE_STATUS.SENT:
      messageStatusIcon = /*#__PURE__*/_react["default"].createElement(StyledSentIcon, null);
      break;
    case _constants.MESSAGE_STATUS.RECEIVED:
      messageStatusIcon = /*#__PURE__*/_react["default"].createElement(StyledReceivedIcon, null);
      break;
    case _constants.MESSAGE_STATUS.READ:
      messageStatusIcon = /*#__PURE__*/_react["default"].createElement(StyledReadIcon, null);
      break;
    default:
      messageStatusIcon = null;
  }
  var icon = null;
  if (isCreateNewConversation) {
    icon = /*#__PURE__*/_react["default"].createElement(StyledWrapperCreateNewConversation, null, /*#__PURE__*/_react["default"].createElement(CreateNewConversationIcon, null));
  } else if (type) {
    icon = /*#__PURE__*/_react["default"].createElement(StyledMessenger, {
      type: type
    });
  }
  var isValidCount = (0, _isInteger2["default"])(unreadAmount) && unreadAmount > 0;
  return /*#__PURE__*/_react["default"].createElement(StyledConversationCard2, props, icon, /*#__PURE__*/_react["default"].createElement(StyledContainer, null, /*#__PURE__*/_react["default"].createElement(StyledTitle, null, title), to && /*#__PURE__*/_react["default"].createElement(StyledWraper, null, to), /*#__PURE__*/_react["default"].createElement(StyledWraper, null, !!time && /*#__PURE__*/_react["default"].createElement(StyledTime, {
    time: time
  }), isHasStatus && messageStatusIcon)), /*#__PURE__*/_react["default"].createElement(StyledCountContainer, null, isValidCount && /*#__PURE__*/_react["default"].createElement(_Count["default"], {
    value: unreadAmount
  })));
});
ConversationCard2.displayName = 'ConversationCard2';
ConversationCard2.propTypes = {
  className: _propTypes["default"].string,
  isHasStatus: _propTypes["default"].bool,
  isCreateNewConversation: _propTypes["default"].bool,
  title: _propTypes["default"].string.isRequired,
  time: _propTypes["default"].number,
  to: _propTypes["default"].string,
  unreadAmount: _propTypes["default"].number,
  type: _propTypes["default"].oneOf(Object.values(Types)),
  messageStatus: _propTypes["default"].oneOf(Object.values(_constants.MESSAGE_STATUS))
};
ConversationCard2.defaultProps = {
  className: '',
  isHasStatus: false,
  isCreateNewConversation: false,
  time: null,
  to: null,
  unreadAmount: null,
  type: null,
  messageStatus: _constants.MESSAGE_STATUS.NONE
};
var StyledConversationCard2 = _styledComponents["default"].div.withConfig({
  displayName: "ConversationCard2__StyledConversationCard2",
  componentId: "sc-jgrlat-0"
})(["min-height:65px;display:flex;"]);
var StyledWrapperCreateNewConversation = _styledComponents["default"].div.withConfig({
  displayName: "ConversationCard2__StyledWrapperCreateNewConversation",
  componentId: "sc-jgrlat-1"
})(["width:24px;height:18px;border-radius:50%;overflow:hidden;margin-top:8px;margin-right:6px;> svg{height:100%;width:100%;}"]);
var StyledMessenger = (0, _styledComponents["default"])(_Messenger["default"]).withConfig({
  displayName: "ConversationCard2__StyledMessenger",
  componentId: "sc-jgrlat-2"
})(["height:18px;margin-top:8px;margin-right:6px;min-width:24px;> svg{height:100%;width:100%;}"]);
var StyledSentIcon = (0, _styledComponents["default"])(_iconsReact.Sent).withConfig({
  displayName: "ConversationCard2__StyledSentIcon",
  componentId: "sc-jgrlat-3"
})(["min-width:20px;height:14px;margin-left:5px;"]);
var StyledReadIcon = (0, _styledComponents["default"])(_iconsReact.Read).withConfig({
  displayName: "ConversationCard2__StyledReadIcon",
  componentId: "sc-jgrlat-4"
})(["min-width:20px;height:14px;margin-left:5px;"]);
var StyledReceivedIcon = (0, _styledComponents["default"])(_iconsReact.Received).withConfig({
  displayName: "ConversationCard2__StyledReceivedIcon",
  componentId: "sc-jgrlat-5"
})(["min-width:20px;height:14px;margin-top:2px;margin-left:5px;"]);
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "ConversationCard2__StyledContainer",
  componentId: "sc-jgrlat-6"
})(["flex-grow:1;line-height:1;margin-top:7px;"]);
var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "ConversationCard2__StyledTitle",
  componentId: "sc-jgrlat-7"
})(["color:#4d4d4d;min-height:17px;font-size:14px;line-height:normal;overflow:hidden;"]);
var StyledWraper = _styledComponents["default"].div.withConfig({
  displayName: "ConversationCard2__StyledWraper",
  componentId: "sc-jgrlat-8"
})(["display:flex;flex-grow:1;font-size:12px;margin:3px 0;color:#919499;"]);
var StyledTime = (0, _styledComponents["default"])(_TimeFrom["default"]).withConfig({
  displayName: "ConversationCard2__StyledTime",
  componentId: "sc-jgrlat-9"
})(["margin-top:2px;cursor:pointer;"]);
var StyledCountContainer = _styledComponents["default"].div.withConfig({
  displayName: "ConversationCard2__StyledCountContainer",
  componentId: "sc-jgrlat-10"
})(["width:23px;margin-top:5px;margin-left:5px;"]);
var CreateNewConversationIcon = (0, _styledComponents["default"])(_iconsReact.CreateNewConversation).withConfig({
  displayName: "ConversationCard2__CreateNewConversationIcon",
  componentId: "sc-jgrlat-11"
})(["width:18px;heigth:19px;"]);
var _default = exports["default"] = ConversationCard2;